import React from 'react';
import { GlobalVariable } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import { dataTypeToHumanReadable } from '@src/common/utils';
import { useTranslation } from '@hooks/index';
import styles from '../GlobalVariablesPanel.module.css';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string, value: SupportedTypes, type: DataType) => void;
}

/**
 * Anything control component for global variables
 * Displays the human-readable name of the last detected data type
 * 
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes (not used for anything type but required by interface)
 */
const AnythingControl = ({ variable }: Props) => {
  const t = useTranslation('GlobalVariablesPanel');
  const dataTypeName = dataTypeToHumanReadable(t as any, variable.lastDataType || DataType.Anything);

  if (!variable.lastValue) {
    return (
      <div className={styles.ControlValue}>
        {t('NoValue')}
      </div>
    );
  }

  return (
    <div className={styles.ControlValue}>
      <span style={{ color: 'rgba(255, 255, 255, 0.5)', marginRight: '8px' }}>
        {`<${dataTypeName}>`}
      </span>
      {/* <span>{String(variable.lastValue ?? '')}</span> */}
    </div>
  );
};

export default AnythingControl;

